import SvgIcon from '@mui/material/SvgIcon';
const Crown = (props) => (<SvgIcon {...props} viewBox="0 0 24 24"><path d="M3 7l4 3 5-5 5 5 4-3-2 10H5L3 7zM6 19h12v2H6v-2z"/></SvgIcon>);
export default Crown;